<template>
  <div class="modal notification-modal" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
       role="dialog"
       style="display:block; background-color:rgba(255, 255, 255, 0.6);">
    <div class="modal-dialog-centered modal-base">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">한건 업로드(상세)</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">
            <div class="info-div" style="overflow-x:auto;">

              <table class="info-table">
                  <colgroup>
                    <col width="40%">
                    <col width="60%">
                  </colgroup>
                  <tr>
                    <td>지역</td>
                    <td class="w-50">
                      <input class="form-control" :placeholder="'전국'" v-model="selectedRegion" readonly>
                    </td>
                  </tr>
                  <tr>
                    <td>사업자번호</td>
                    <td class="w-50">
                      <input class="form-control" :placeholder="'전체'" v-model="selectedCompany" readonly>
                    </td>
                  </tr>
                <tr>
                  <td>시작일 </td>
                  <td>
                    <input name="selectStartDay" id="selectStartDay" class="form-control" type="date"
                           v-model="formData.startDay" min="2000-01-01"
                           max="2999-12-31" readonly />
                  </td>
                </tr>

                <tr>
                  <td>종료일 </td>
                  <td>
                    <div class="'col mb-3'">
                      <input name="selectEndDay" id="selectEndDay" class="form-control" type="date"
                             v-model="formData.endDay" min="2000-01-01" max="2999-12-31" readonly/>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td> 사업자 구분 </td>
                  <td>
                    <input class="form-control" :placeholder="'전체'" v-model="carType" readonly/>
                  </td>
                </tr>
                  <tr>
                    <td>차량번호</td>
                      <td class="w-50">
                        <div class="d-flex align-items-center gap-2">
                        <label class="mb-0">
                          부분일치
                          <input type="checkbox" id="carNumLike"  v-model="carNumLike">
                        </label>
                        <input class="form-control" :placeholder="'전체'" v-model="selectedCarNum"
                               list="carNumDatalist" readonly />
                        </div>
                    </td>
                  </tr>
                <tr>
                  <td>추출 타입</td>
                  <td style="padding-left: 30px">

                    <input class="form-control" v-model="extractionType" readonly />

                  </td>
                </tr>
                </table>


            </div>
          
        </div>

        <div class="modal-footer">
<!--          <button type="button" class="btn btn-primary" @click="extraction">추출하기</button>-->
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref} from "vue";
import {useStore} from "vuex";
import axios from "@/composables/Axios";
import tachoEntity from "@/entity/TachoEntity";
import Entity from "@/entity/OperationEntity";
import dayjs from "dayjs";
import CarNumWithSearchInput from "@/components/tacho/searchbar/CarNumWithSearchInput.vue";
import {changeFormat, datePlus1day} from "@/components/tacho/common/CommonFunc";
const url = tachoEntity.baseUrl;
const ezlUrl =  tachoEntity.tachodUrl;
const store = useStore();
const carType = ref("");
const operationUrl = store.state['api'].operationUrl;
const entity = new Entity.organizationHeaders(store.state.sign['userInfo'].userId);
const header = entity.get();
const formData = new tachoEntity.drivingSearchDto()
const regionList = ref([]);
const selectedRegion = ref();
const selectedCompany = ref();
const setLoading = (value) => store.commit('setLoading', value)
const companyList = ref([]);
const typeList = ref(['DETAIL']);
const reqType = ref("DETAIL");
const resData = ref("");
const selectedType = (e) => {

  reqType.value = e.target.value;
}
const props = defineProps({
  regionList: Object,
  resData : String
})
const downloadTF = ref(true);
const fileName = ref("");
const resultData = ref({status:"",result:"",uploadDate:"",id:-1});
const selectedCarType = ref("전체");
const carNumList = ref();
const carNumLike = ref();
const selectedCarNum = ref();
const extractionType = ref();
const emit = defineEmits(['close', 'refreash']);
let queryParam = new tachoEntity.vehicleQueryParam();
onMounted(async () =>{
  formData.startDate = changeFormat(formData.startDate,'YYYY-MM-DDTHH:mm:ss');
  formData.startDay = changeFormat(formData.startDate,'YYYY-MM-DD');

  selectStartDay.value =  changeFormat( formData.startDay, 'YYYY-MM-DD');

  let end = datePlus1day(formData.startDay);
  selectEndDay.min = formData.startDay;
  selectEndDay.value =  changeFormat( end, 'YYYY-MM-DD');

  formData.endDate = changeFormat(end,'YYYY-MM-DDTHH:mm:ss');
  formData.endDay = changeFormat(end,'YYYY-MM-DD');

  const typeres = await axios.$get(`${ezlUrl}data-extraction/type`, {}, header);
  typeList.value = typeres.data;

  await validate();
})
//
// const extraction = async () => {
//   //업로드
//   await validate();
// }

const validate = async () => {
    try {
      let headers = entity.get();

      const res = await axios.$get(`${ezlUrl}data-extraction/job/list/${props.resData}`, {}, headers);
      let result = res.data[0];
      selectedRegion.value  = result.city_name;   //지역
      formData.startDay =changeFormat(result.start_date,'YYYY-MM-DD');      //시작일
      formData.endDay = changeFormat(result.end_date,'YYYY-MM-DD');         //종료일
      selectedCompany.value = result.office_id;   //사업자번호
      selectedCarNum.value = result.car_num;      //차량번호
      carNumLike.value = result.car_num_like;   // 차량번호 입력타입
      extractionType.value = result.req_type;  // 추출타입
      if (result.car_type){     //사업자구분
        carType.value = (result.car_type=="21") ? "법인" : "개인";
      }else {
        carType.value = "전체"
      }
  } catch (error) {
     alert("데이터가 존재하지 않습니다")
  }
}

</script>

<style scoped>
.dropdown-wrapper {
  position: relative;
  width: 100%;
}
.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background: white;
  z-index: 1000;
  padding: 0;
  margin: 0;
  list-style: none;
}
.dropdown-list li {
  padding: 8px 12px;
  cursor: pointer;
}
.dropdown-list li:hover {
  background-color: #f1f1f1;
}

</style>